import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Overlay } from '@angular/cdk/overlay';
import { FileExportStore } from '../state/file-export.store';
import { tap } from 'rxjs';

import { FileExportComponent } from './file-export.component';
import { Dialog, DialogRef } from '@angular/cdk/dialog';

@Injectable({ providedIn: 'root' })
export class FileExportUiService {
  private fileExportStore = inject(FileExportStore);

  private readonly dialog = inject(Dialog);
  private readonly overlay = inject(Overlay);

  private dialogRef!: DialogRef<unknown, FileExportComponent>;

  files$ = toObservable(this.fileExportStore.files).pipe(
    tap((files) => {
      if (files.length >= 1 && !this.dialogRef?.overlayRef?.hasAttached()) {
        this.displayOverlay();
      }

      if (files.length === 0 && this.dialogRef?.overlayRef?.hasAttached()) {
        this.dialogRef?.overlayRef.detach();
        this.dialogRef?.overlayRef.dispose();
      }
    }),
  );

  private displayOverlay() {
    this.dialogRef = this.dialog.open(FileExportComponent, {
      hasBackdrop: false,
      panelClass: 'file-export-dialog',
      positionStrategy: this.overlay.position().global().bottom('28px').right('28px'),
    });
  }
}
